const isResponsable = (user) => {
  if (!user?.profile) {
    return false
  }

  return user.responsable
}

export default isResponsable
